import { useQuery } from '@tanstack/react-query'
import { sessionQueryOptions } from '../api/queries'
import type { Session } from '../model/types'

interface UseSessionResult {
  session: Session | null
  isLoading: boolean
  isAuthenticated: boolean
  isAdmin: boolean
}

export function useSession(): UseSessionResult {
  const { data, isLoading } = useQuery(sessionQueryOptions)
  return {
    session: data ?? null,
    isLoading,
    isAuthenticated: data != null,
    isAdmin: data?.isAdmin ?? false,
  }
}
